/* eslint-disable */
var ApplicationHelpers = {
  formatString: function (value) {
    return value || '';
  },

  formatBoolean: function (value) {
    // TODO: Remove if body parser is updated to allow input name overriding
    if (typeof value == 'object') {
      value = value[value.length - 1];
    }
    return value && value.toString() === 'true';
  },

  formatStrictBoolean: function (value) {
    // TODO: Remove if body parser is updated to allow input name overriding
    if (typeof value == 'object') {
      value = value[value.length - 1];
    }
    if (value && value.toString() === 'true') {
      return true;
    } else if (value && value.toString() === 'false') {
      return false;
    }
    return null;
  },

  formatShortDate: function (date, options) {
    if (options === true) {
      options = {
        noDay: true
      };
    }

    if (typeof options === 'undefined') {
      options = {};
    }

    if (date === undefined || date === true) {
      if (!options.noLife) {
        return 'Life';
      } else {
        return '';
      }
    }
    date = new Date(date);
    if (date && !isNaN(date.getUTCMonth()) && !isNaN(date.getUTCFullYear()) && !isNaN(date.getUTCDate())) {
      if (options.noDay) {
        var month = (date.getUTCMonth() + 1).toString();
        if (month.length < 2 && !options.noLeadingZero) {
          month = '0' + month;
        }
        return [month, date.getUTCFullYear()].join('/');
      } else {
        return [date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCFullYear()].join('/');
      }
    }

    return '';
  },
  formatDate: function (value) {
    if (typeof value === 'object' && value !== null && value !== undefined) {
      var month = parseInt(value.month, 10) || null;
      var year = parseInt(value.year, 10) || null;
      if (typeof month == 'number' && typeof year == 'number') {
        return new Date(
          year,
          month - 1,
          parseInt(value.day, 10) || 1,
          parseInt(value.hour, 10) || null,
          parseInt(value.minutes, 10) || null,
          parseInt(value.seconds, 10) || null,
          parseInt(value.milliseconds, 10) || null
        ).toUTCString();
      } else if (value instanceof Date) {
        return value.toUTCString();
      } else {
        return null;
      }
    } else if (typeof value === 'string') {
      var value = new Date(value);
      if (value != 'Invalid Date') {
        return value.toUTCString();
      } else {
        return null;
      }
    }
  },

  formatyyyymmdd: function (value) {
    var mm = value.getMonth() + 1; // getMonth() is zero-based
    var dd = value.getDate();

    if (value) {
      var result = [value.getFullYear(), !mm[1] && '0', mm, !dd[1] && '0', dd].join(''); // padding
    } else {
      var result = '';
    }

    if (dd == 1) console.log(value, result);

    return result;
  },

  formatLongDate: function (date, noDay) {
    if (date instanceof Date) {
      var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      var month = monthNames[date.getUTCMonth()];
      var day = date.getUTCDate();
      var year = date.getUTCFullYear();

      if (!noDay) {
        return month + ' ' + day + ', ' + year;
      } else {
        return month + ' ' + year;
      }
    } else return '';
  },

  formatPhone: function (value) {
    var phoneRegex = /^([\+]?[0-9]?)[\s\-]?[\(]?([0-9]{3})[\)]?[\-\s\.]?([0-9]{3})[\-\s\.]?([0-9]{4})$/,
      phone = phoneRegex.exec(value),
      phoneNumber;

    if (phone !== null) {
      phoneNumber = phone[2] && phone[3] && phone[4] ? phone[2] + '-' + phone[3] + '-' + phone[4] : null;
      if (phone[1] !== '') phoneNumber = phone[1] + '-' + phoneNumber;
    } else {
      phoneNumber = null;
    }

    return phoneNumber;
  },

  formatPercent: function (value) {
    if (value === null || value === undefined || value === '' || (typeof value == 'number' && isNaN(value))) {
      return '';
    }

    return parseFloat(value, 10).toFixed(2) + '%';
  },

  formatCurrency: function (value) {
    if (value === null || value === undefined || value === '' || (typeof value == 'number' && isNaN(value))) {
      return '';
    }

    var number = value;
    number = number.toString().replace(/\$|\,/g, '');
    if (isNaN(number)) {
      return number;
    }
    var sign = number == (number = Math.abs(number));
    number = Math.floor(number * 100 + 0.50000000001);
    var cents = number % 100;
    number = Math.floor(number / 100).toString();

    if (cents > 49) {
      number = parseInt(number++).toString();
    }

    for (var i = 0; i < Math.floor((number.length - (1 + i)) / 3); i++) {
      number = number.substring(0, number.length - (4 * i + 3)) + ',' + number.substring(number.length - (4 * i + 3));
    }

    return (sign ? '' : '-') + '$' + number;
  },

  /* commenting apparantly duplicate
    Saeed on 23 Feb
    formatCent : function(value) {
      if (value === null || value === undefined || value === "" || (typeof value == "number" && isNaN(value))) {
        return "";
      }

      var number = value;
      number = number.toString().replace(/\$|\,/g,'');
      if(isNaN(number)) {
        return number;
      }

      sign = (number == (number = Math.abs(number)));

      number = Math.floor(number*100+0.50000000001);
      cents = number%100;
      number = Math.floor(number/100).toString();

      if (cents > 49) {
        number = parseInt(number++).toString();
      }

      for (var i = 0; i < Math.floor((number.length - (1+i))/3); i++) {
        number = number.substring(0, number.length - (4*i+3)) + ',' + number.substring(number.length-(4*i+3));
      }

      cents = Math.floor(cents);
      if(cents < 10) {
        cents = '0' + cents;
      }

      return  (sign ? '' : '-') + '$' + number + '.' + cents;
    },*/

  formatCent: function (value) {
    if (value === null || value === undefined || value === '' || (typeof value == 'number' && isNaN(value))) {
      return '';
    }

    var number = value;
    number = number.toString().replace(/\$|\,/g, '');
    if (isNaN(number)) {
      return number;
    }

    var sign = number == (number = Math.abs(number));

    number = Math.floor(number * 100 + 0.50000000001);
    var cents = number % 100;
    number = Math.floor(number / 100).toString();

    if (cents > 49) {
      number = parseInt(number++).toString();
    }

    for (var i = 0; i < Math.floor((number.length - (1 + i)) / 3); i++) {
      number = number.substring(0, number.length - (4 * i + 3)) + ',' + number.substring(number.length - (4 * i + 3));
    }

    cents = Math.floor(cents);
    if (cents < 10) {
      cents = '0' + cents;
    }

    return (sign ? '' : '-') + '$' + number + '.' + cents;
  },

  optionsForSelect: function (options, selected, includeEmpty) {
    var buffer = [];
    var selection = false;
    var isArray = Array.isArray(options);
    for (var i in options) {
      if (typeof options[i] === 'object') {
        buffer = buffer.concat([
          '<optgroup label="',
          i,
          '" value="0">',
          ApplicationHelpers.optionsForSelect(options[i], selected, false),
          '</optgroup>'
        ]);
      } else {
        if (typeof selected != 'undefined') {
          var isSelected = isArray ? options[i] == selected : i == selected.toString();
          if (isSelected) {
            selection = true;
          }
        }
        buffer = buffer.concat([
          '<option value="',
          isArray ? options[i] : i,
          '"',
          isSelected ? ' selected' : '',
          '>',
          options[i],
          '</option>'
        ]);
      }
    }

    if (includeEmpty) {
      buffer = ['<option value=""', !selection ? ' selected' : '', '></option>'].concat(buffer);
    }
    return buffer.join('');
  },

  optionsForSelectBasic: function (options, selected, includeEmpty) {
    var buffer = [];
    var selection = false;
    for (var i in options) {
      if (typeof options[i] === 'object') {
        var isSelected = options[i].key == selected;
        // buffer = buffer.push("<option value=\"" + options[i].key + "\"" + isSelected ? " selected" : "" + ">" + options[i].label + "</option>");
        buffer = buffer.concat([
          '<option value="',
          options[i].key,
          '"',
          isSelected ? ' selected' : '',
          '>',
          options[i].label,
          '</option>'
        ]);
      }
    }
    return buffer.join('');
  },
  ageAt: function (birthdate, date, yearOnly, yearWording) {
    yearOnly = yearOnly || false;
    if (!birthdate || !date) {
      return '';
    }
    birthdate = new Date(birthdate);

    var years = date.getUTCFullYear() - birthdate.getUTCFullYear();
    var months = 0;

    if (date.getUTCMonth() > birthdate.getUTCMonth()) {
      months = date.getUTCMonth() - birthdate.getUTCMonth();
    } else if (date.getUTCMonth() < birthdate.getUTCMonth()) {
      years--;
      months = date.getUTCMonth() - birthdate.getUTCMonth() + 12;
    }

    if (months > 0) {
      if (months == 1) {
        months = ' ' + months + ' month';
      } else {
        months = ' ' + months + ' months';
      }
    } else {
      months = '';
    }
    if (yearOnly) return years;

    return years + (years == 1 ? ' year' : ' years') + months;
  },

  dateAtAge: function (age, birthdate) {
    var b = new Date(birthdate);
    return new Date(b.getUTCFullYear() + age, b.getUTCMonth(), b.getUTCDate());
  },

  parseCurrency: function (currency) {
    if (currency === '' || currency === null || currency === undefined) {
      return 0;
    } else if (typeof currency === 'number') {
      return currency;
    }

    return parseFloat(currency.replace(/[$,]+/g, ''), 10);
  },

  parsePercent: function (value) {
    if (typeof value === 'undefined' || value === null) return null;
    if (typeof value === 'number') return value;
    if (typeof value === 'object') value = value[value.length - 1];
    if (typeof value === 'string') {
      value = value.toString().replace(',', '');
      value = parseFloat(value.toString().replace('%', ''), 10);
    }
    return typeof value === 'number' && !isNaN(value) ? value : null;
  },

  /**
   * Takes HTML date inputs and returns a Date object representing them
   * @param field {Object} jQuery object representing the HTML date field component.
   * @return Date
   */
  dateFieldToDate: function (field) {
    return new Date(
      field.find('.year input').val(),
      parseInt(field.find('.month input').val(), 10) - 1,
      field.find('.day input').val()
    );
  },
  shortDateFieldToDate: function (field) {
    return new Date(field.find('.year input').val(), parseInt(field.find('.month input').val(), 10) - 1, 1);
  },
  /**
   * Convert date to CST timezone, required format if provided, default format is MM/DD/YYYY
   * @param date {date}
   * @param format {string}
   */
  getDisplayDate: function (date) {
    date = new Date(date);

    if (isNaN(+date)) {
      return '';
    }

    var displayDate = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours() - 5,
      date.getMinutes(),
      date.getSeconds()
    );

    var hours = displayDate.getUTCHours(),
      am = 'am';
    if (hours > 12) {
      hours = hours - 12;
      am = 'pm';
    }

    var minutes = displayDate.getMinutes();
    if (minutes < 10) minutes = '0' + minutes;

    var output = '';

    output += displayDate.getUTCMonth() + 1 + '/';
    output += displayDate.getUTCDate() + '/';
    output += displayDate.getUTCFullYear() + ' ';
    output += hours + ':' + minutes + am + ' CST';

    return output;
  },

  displayMonth: [
    'January',
    'Feburary',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],

  states: [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
  ],

  statePensionWebsites: {
    AL: 'http://www.rsa-al.gov/',
    AK: 'http://doa.alaska.gov/drb/',
    AZ: 'https://www.azasrs.gov/web/Home.do',
    AR: 'http://www.apers.org/',
    CA: 'http://www.calpers.ca.gov/',
    CO: 'http://www.colorado.gov/dpa/dhr/benefits',
    CT: 'http://www.ct.gov/',
    DE: 'http://www.delawarepensions.com/',
    DC: 'http://dcrb.dc.gov/dcrb/site/default.asp',
    FL: 'http://www.dms.myflorida.com/human_resource_support/retirement',
    GA: 'http://www.ers.ga.gov/',
    HI: 'http://ers.ehawaii.gov/',
    ID: 'http://persi.idaho.gov/',
    IL: 'http://www.state.il.us/SRS/',
    IN: 'http://www.in.gov/inprs/overview.htm',
    IA: 'http://www.ipers.org/',
    KS: 'http://www.kpers.org/',
    KY: 'http://kyret.ky.gov/',
    LA: 'http://www.lasersonline.org/site.php',
    ME: 'http://www.mainepers.org/',
    MD: 'http://www.sra.state.md.us/',
    MA: 'http://www.mass.gov/',
    MI: 'http://www.michigan.gov/ors/',
    MN: 'http://www.msrs.state.mn.us/',
    MS: 'http://www.pers.ms.gov/Pages/Home.aspx',
    MO: 'https://www.psrs-peers.org/',
    MT: 'http://mpera.mt.gov/index.shtml',
    NE: 'https://npers.ne.gov/',
    NV: 'http://www.nvpers.org/',
    NH: 'http://www.nhrs.org/',
    NJ: 'http://www.state.nj.us/treasury/pensions/pers1.shtml',
    NM: 'http://www.pera.state.nm.us/',
    NY: 'http://www.osc.state.ny.us/retire/',
    NC: 'https://www.nctreasurer.com/Retirement-And-Savings/Managing-My-Retirement/Pages/default.aspx',
    ND: 'http://www.nd.gov/ndpers/retirement-plans/db-plan.html',
    OH: 'https://www.opers.org/',
    OK: 'http://www.opers.ok.gov/',
    OR: 'http://www.oregon.gov/PERS/',
    PA: 'http://www.sers.state.pa.us/portal/server.pt/community/sers_home/14364',
    RI: 'https://www.ersri.org/',
    SC: 'http://www.retirement.sc.gov/',
    SD: 'http://www.sdrs.sd.gov/',
    TN: 'http://treasury.tn.gov/tcrs/',
    TX: 'http://www.texpers.org/',
    UT: 'https://www.urs.org/',
    VT: 'http://www.vermonttreasurer.gov/retirement/state-vsrs',
    VA: 'http://www.varetire.org/',
    WA: 'http://www.drs.wa.gov/',
    WV: 'http://www.wvretirement.com/PERS%20Plan%20Description.html',
    WI: 'http://etf.wi.gov/members/benefits_wrs.htm',
    WY: 'https://www.wvretirement.com/PERS.html'
  },

  stateAbbr: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  stateTaxRates: {
    AL: 3.5,
    AK: 0,
    AZ: 3.56,
    AR: 4,
    CA: 7.15,
    CO: 4.4,
    CT: 4.85,
    DE: 4.4,
    DC: 6.47,
    FL: 0,
    GA: 3.5,
    HI: 6.2,
    ID: 4.5,
    IL: 5,
    IN: 3.4,
    IA: 3.9,
    KS: 3.8,
    KY: 4,
    LA: 4,
    ME: 7.23,
    MD: 3.87,
    MA: 5.25,
    MI: 4.25,
    MN: 7.6,
    MS: 4,
    MO: 3.75,
    MT: 3.95,
    NE: 4.65,
    NV: 0,
    NH: 5,
    NJ: 5.18,
    NM: 3.3,
    NY: 6.41,
    NC: 5.8,
    ND: 2.75,
    OH: 2.96,
    OK: 2.87,
    OR: 7.45,
    PA: 3.07,
    RI: 4.87,
    SC: 3.5,
    SD: 0,
    TN: 6,
    TX: 0,
    UT: 5,
    VT: 6.25,
    VA: 3.87,
    WA: 0,
    WV: 4.75,
    WI: 5.82,
    WY: 0
  },
  stateLTCCosts: {
    AL: [5962, 2894],
    AK: [20075, 5500],
    AZ: [7080, 3150],
    AR: [5201, 2850],
    CA: [8669, 3750],
    CO: [7665, 3313],
    CT: [12927, 5289],
    DC: [9216, 6890],
    DE: [9429, 5500],
    FL: [7635, 3000],
    GA: [5825, 2500],
    HI: [11254, 4750],
    ID: [7095, 3275],
    IL: [6220, 3805],
    IN: [7148, 3724],
    IA: [5627, 3418],
    KS: [5323, 3730],
    KY: [6692, 3264],
    LA: [4897, 3156],
    ME: [8973, 4950],
    MD: [8722, 3400],
    MA: [11193, 5247],
    MI: [7893, 3200],
    MN: [7379, 3403],
    MS: [6388, 2900],
    MO: [4988, 2500],
    MT: [6570, 3300],
    NE: [6132, 3298],
    NV: [7495, 3250],
    NH: [9885, 4373],
    NJ: [9885, 5430],
    NM: [6903, 3500],
    NY: [10889, 3684],
    NC: [6844, 2940],
    ND: [7802, 3105],
    OH: [7265, 3971],
    OK: [4791, 3082],
    OR: [8060, 4000],
    PA: [8958, 3280],
    RI: [9125, 4895],
    SC: [6083, 2874],
    SD: [5901, 3110],
    TN: [6007, 3465],
    TX: [5475, 3523],
    UT: [6083, 3061],
    VT: [9201, 4075],
    VA: [7026, 3990],
    WA: [8502, 4250],
    WV: [8060, 3465],
    WI: [8121, 3850],
    WY: [7361, 3090]
  },
  limit: function (val, max) {
    // if (val.length === 1 && val[0] > max[0]) {
    //   val =  val;
    // }

    if (val.length === 2) {
      if (Number(val) === 0) {
        val = '1';

        //this can happen when user paste number
      } else if (val > max) {
        val = max;
      }
    }
    return val;
  },
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  decimalFormat: function (val) {
    var floatNum = ApplicationHelpers.limit(val.substring(0, 1), '9');
    let decimalNum = val.substring(1, 3);

    return floatNum + (decimalNum.length ? '.' + decimalNum : '') + '%';
  }
};

if (typeof module !== 'undefined') {
  module.exports = ApplicationHelpers;
}
